import { Injectable, EventEmitter } from '@angular/core';


@Injectable()
export class AppGlobals {
    // public showVideo: EventEmitter<any> = new EventEmitter();
}


